import ChangeAdminModal from './ChangeAdminModal';

export default ChangeAdminModal;
